import jQuery from 'jquery';
import { Breakpoint, Breakpoints } from './constants';

export default class ThemeBase {
    /** @type {jQuery} */
    $;

    /** @type {Object.<string, string>} */
    translations;

    /** @type {string} */
    moneyFormat;

    /** @type {Breakpoint} */
    breakpoint;

    /**
     * Take monetary value and format it as money in
     *
     * @param {number | string} cents Price in cents (hundreds of base unit)
     * @param {string} [format] Format for money, store format will be used if undefined
     * @return {string} HTML with the formatted money value
     */
    formatMoney = (cents, format) => {
        var moneyFormat = this.moneyFormat;
        if (typeof cents === 'string') {
            cents = cents.replace('.', '');
        }
        var value = '';
        var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        var formatString = (format || moneyFormat);

        function formatWithDelimiters(number, precision, thousands, decimal) {
            if (precision === null || precision === undefined) {
                precision = 2;
            }
            thousands = thousands || ',';
            decimal = decimal || '.';

            if (isNaN(number) || number == null) {
                return 0;
            }

            number = (number / 100.0).toFixed(precision);

            var parts = number.split('.');
            var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
            var centsAmount = parts[1] ? (decimal + parts[1]) : '';

            return dollarsAmount + centsAmount;
        }

        switch (formatString.match(placeholderRegex)[1]) {
            case 'amount':
                value = formatWithDelimiters(cents, 2);
                break;
            case 'amount_no_decimals':
                value = formatWithDelimiters(cents, 0);
                break;
            case 'amount_with_comma_separator':
                value = formatWithDelimiters(cents, 2, '.', ',');
                break;
            case 'amount_no_decimals_with_comma_separator':
                value = formatWithDelimiters(cents, 0, '.', ',');
                break;
            case 'amount_no_decimals_with_space_separator':
                value = formatWithDelimiters(cents, 0, ' ');
                break;
        }

        return '<span class="money">' + formatString.replace(placeholderRegex, value) + '</span>';
    }

    /**
     * Return current width of the window including scrollbar
     *
     * @returns {number} width of the window
     */
    getWindowWidth = () => {
        return Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }

    /**
     * Get breakpoint for given width or window if null not defined
     *
     * @param {number} width Width for which we want breakpoint
     * @returns {import('./constants').Breakpoint} Name of matching breakpoint
     */
    getBreakpoint = (width = undefined) => {
        const w = width === null || width === undefined ? this.getWindowWidth() : width;
        let breakpoint;
        Object.values(Breakpoints).forEach(
            (b) => {
                if (w >= b.min && w <= b.max) {
                    breakpoint = b;
                }
            }
        );
        return breakpoint;
    }

    /**
     * Load dynamic icons
     *
     * @param {HTMLElement} element
     */
    loadIcons = (element = null) => {}

    /**
     * Update cart drawer after cart content was changed
     *
     * @param {Cart} cart
     */
    updateCartDrawer = (cart) => {}

    /**
     * Load Youtube javascript API
     *
     * @return {Promise<import('./window').YoutubeApi>} Promise to be resolved when the API is loaded
     */
    loadYoutubeApi = () => { return; }

    /**
     * Load Vimeo javascript API
     *
     * @return {Promise<import('./window').VimeoApi>} Promise to be resolved when the API is loaded
     */
    loadVimeoApi = () => { return; }

    /**
     * Load Vimeo javascript API
     *
     * @param {string} apiKey Google Maps API key
     * @return {Promise<import('./window').GoogleMapsApi>} Promise to be resolved when the API is loaded
     */
    loadGoogleMapApi = (apiKey) => { return; }

    /**
     * Make sure a `<script>` tag with given `id` and `src` exist, create one if not
     *
     * @param {string} id
     * @param {string} src
     * @return {HTMLScriptElement}
     */
    createScript = (id, src) => { return; }

    /**
     * Register a component to receive global events (like onResize)
     *
     * @param {Object} component
     */
    registerComponent = (component) => {}
}
